module.exports = __webpack_public_path__ + "/login_ui/img/pk-3f3d62b4a2d4a0748786a26d396f94e1.svg";